import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import prefsReducer from './slices/prefsSlice';
import globalReducer from './slices/globalSlice';
import gridReducer from './slices/gridSlice';
import mapReducer from './slices/mapSlice';
import { customerApi } from './api';
import { filtersReducer } from './slices/filtersSlice';
import healthReducer from './slices/healthSlice';
import locationFilterReducer from './slices/locationFilterSlice';
import investigationsReducer from './slices/investigationsSlice';
import investigationGuiReducer from './slices/investigationGuiSlice';

export const store = configureStore({
  reducer: {
    api: customerApi.reducer,
    auth: authReducer,
    health: healthReducer,
    prefs: prefsReducer,
    global: globalReducer,
    filters: filtersReducer,
    grid: gridReducer,
    map: mapReducer,
    locationFilter: locationFilterReducer,
    investigations: investigationsReducer,
    investigationGui: investigationGuiReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(customerApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
